import watch   from "redux-watch";
import isEqual from 'is-equal';
import visit   from 'utilities/visit';
export default class ResponseThen {
  init(){
    let scope = 'data.response_then';
    let w = watch(App.store.getState, scope, isEqual);
    App.store.subscribe(w((newVal, oldVal, objectPath) => {
      this.onResponse(newVal, oldVal, objectPath);
    }), true);
  }
  onResponse(newVal, oldVal, projectPath){
    if(newVal == null){ return; }
    if(newVal.method == 'redirect_to') {
      visit(newVal.options.path);
    }else if(newVal.method == 'blank_to'){
      App.location.blank(newVal.options.path)
    }else if(newVal.method == 'refresh_to'){
      App.location.refresh(newVal.options.path)
    }
  }
}
